import { getTimezoneOffset } from "date-fns-tz";

export function getQueryStringValue(key) {
  return decodeURIComponent(
    window.location.search.replace(
      new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[.+*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"),
      "$1"
    )
  );
}

// find if value is between ranges inclusive used by replaceInlineStyleByRange uses for TEXTRULE_ACTIVE
export function between(x, start, end, length) {
  // console.log(x, start, end, length);
  if (!end) {
    end = start + length;
  }
  return x >= start && x <= end;
}

// Introducing clog
// For colourful console.log's
export function clog(message, color) {
  const colorString = color ? "color: " + color + ";" : null;
  const messageString = "%c" + message;
  console.log(messageString, colorString);
}

// find if cursor position value is between ranges inclusive of end. This is different from the original between function (above)
// as it appears we need to treat cursor position different from a textrule offset
export function cursorBetweenRange(x, start, end, length) {
  // console.log(x, start, end, length);
  if (!end) {
    end = start + length;
  }
  return x > start && x <= end;
}

// nested list
export function getListItemMark(listType, format, depth) {
  if (listType === "Decimal") {
    listType = "decimal";
  } else if (listType === "LowerLetter") {
    listType = "lower-alpha";
  } else if (listType === "UpperLetter") {
    listType = "upper-alpha";
  } else if (listType === "LowerRoman") {
    listType = "lower-roman";
  } else if (listType === "UpperRoman") {
    listType = "upper-roman";
  }
  var reg = new RegExp(/%[0-9]*/g);
  var index = -1;
  var arr = format.match(reg);
  if (arr === null) {
    return null;
  }
  var len = arr.length;
  var start_append = false;
  var end_append = false;
  var depth_start = depth - len + 1;
  var res = format.replace(reg, function (match, offset) {
    var rep = "";
    index++;
    var level = index + depth_start;
    if (index === 0) {
      if (offset !== 0) {
        rep += '" ';
        start_append = true;
      }
      rep += "counter(level" + level + ", " + listType + ")";
      if (index < len - 1) {
        rep += ' "';
      }
      if (index === len - 1 && offset + match.length < format.length) {
        rep += ' "';
        end_append = true;
      }
    } else if (index < len - 1) {
      rep = '" counter(level' + level + ", " + listType + ') "';
    } else if (index === len - 1) {
      rep = '" counter(level' + level + ", " + listType + ")";
      if (offset + match.length < format.length) {
        rep += ' "';
        end_append = true;
      }
    }
    return rep;
  });
  if (start_append) {
    res = '"' + res;
  }
  if (end_append) {
    res = res + '"';
  }
  return res;
}

export function isListItem(block) {
  const listItem = block.getIn(["data", "listItem"]);

  /*
    Now we don't support list inside table.
    Later we should check only 'listType'
  */
  if (block.type === "unordered-list-item" || block.type === "ordered-list-item") {
    if (
      listItem !== undefined &&
      listItem !== null &&
      listItem.listType !== null &&
      listItem.format !== null &&
      listItem.format !== ""
    ) {
      return true;
    }
  }
  return false;
}

export function twipToPx(twip) {
  return twip / 15;
}

export function pxToPt(px) {
  // 1inch = 72pt
  // 1inch = 96px
  return (px * 72) / 96;
}

/* Creates a uppercase hex number with at least length digits from a given number */
function fixedHex(number, length) {
  var str = number.toString(16).toUpperCase();
  while (str.length < length) str = "0" + str;
  return str;
}

/* Creates a unicode literal based on the string */

export function unicodeLiteral(str) {
  var i;
  var result = "";
  for (i = 0; i < str.length; ++i) {
    /* You should probably replace this by an isASCII test */
    if (str.charCodeAt(i) > 126 || str.charCodeAt(i) < 32) result += "\\u" + fixedHex(str.charCodeAt(i), 4);
    else result += str[i];
  }

  return result;
}

// Generates a unique Id of length checking against supplied existing Ids
export function generateId(existingIdsArray, length = 8, isLowerCase = false) {
  let id = "";
  var chars = isLowerCase ? "abcdef123456789" : "ABCDEF123456789";
  const charsLength = chars.length;

  for (let i = 0; i < length; i++) {
    id += chars.charAt(Math.floor(Math.random() * charsLength));
  }
  // while id is found in existingIdsArray iterate through string changing chars till id is unique
  while (existingIdsArray.includes(id)) {
    for (let j = 0; j < length; j++) {
      id[j] = chars.charAt(Math.floor(Math.random() * charsLength));
    }
  }
  return id;
}

export const LEVEL = {
  TRACE: 0,
  DEBUG: 1,
  INFO: 2,
  WARNING: 3,
  ERROR: 4,
};
var logLevel = LEVEL.ERROR;
export function dlog(level, indentNum, ...msg) {
  console.log("DLOG!!", level, indentNum, ...msg);
  var indent = "";
  for (var i = 0; i < indentNum; i++) {
    indent += "\t";
  }
  if (logLevel <= level) {
    console.log(indent, ...msg);
  }
}

export function dtable(level, obj) {
  if (logLevel <= level) {
    console.table(obj);
  }
}

export const queryString = (function (a) {
  if (a === "") return {};
  var b = {};
  for (var i = 0; i < a.length; ++i) {
    var p = a[i].split("=", 2);
    if (p.length === 1) b[p[0]] = "";
    else b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
  }
  return b;
})(window.location.search.substr(1).split("&"));

// https://github.com/30-seconds/30-seconds-of-code/blob/master/snippets/debounce-promise.md
// self arg added for this binding
export const debouncePromise = (fn, ms = 0, self = this) => {
  let timeoutId;
  const pending = [];
  return (...args) =>
    new Promise((res, rej) => {
      // Each time the debounced function is invoked, clear the current pending timeout with clearTimeout() and use setTimeout()
      // to create a new timeout that delays invoking the function until at least ms milliseconds has elapsed.
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        const currentPending = [...pending];
        pending.length = 0;
        Promise.resolve(fn.apply(self, args)).then(
          (data) => {
            console.log(data);
            currentPending.forEach(({ resolve }) => resolve(data));
          },
          (error) => {
            currentPending.forEach(({ reject }) => reject(error));
          }
        );
      }, ms);
      pending.push({ resolve: res, reject: rej });
    });
};

// ported from ui

/**
 *
 * @param {number} minutes - the offset minutes, such as 240 for UTC-4
 * @returns - 'date.timezoneOffset' is adjusted
 */
// eslint-disable-next-line no-extend-native
Date.prototype.setTimezoneOffset = function (minutes) {
  var _minutes;
  if (this.timezoneOffset == _minutes) {
    _minutes = this.getTimezoneOffset();
  } else {
    _minutes = this.timezoneOffset;
  }
  if (arguments.length) {
    this.timezoneOffset = minutes;
  } else {
    this.timezoneOffset = minutes = this.getTimezoneOffset();
  }
  return this.setTime(this.getTime() + (_minutes - minutes) * 6e4);
};

/**
 *
 * @param {number} d - the timezone offset such as -4 for UTC-4, +9.5 for UTC+9.5
 * @returns - '04:00' or '09:30'
 */
const makeTimeoffset = (d) => {
  const min = d * 60;
  return makeTwo(Math.floor(Math.abs(min) / 60)) + ":" + makeTwo(Math.abs(min) % 60);
};

/**
 *
 * @param {number} d - the month or the date
 * @returns - the 2 digits expression such as '04'
 */
const makeTwo = (d) => ("0" + d).slice(-2);

/**
 *
 * @param {string or number} timezone
 *  the timezone string such as 'Australia/Melborne' or
 *  the timezone minutes such as 240 for UTC-4
 * @returns - the timezone offset such as '-4' for UTC-4
 */
const getTzOffset = (timezone) => {
  let tzOffset = 0;
  if (!timezone) {
    tzOffset = 0 - new Date().getTimezoneOffset() / 60;
  } else if (typeof timezone === "number") {
    tzOffset = 0 - timezone / 60;
  } else {
    tzOffset = getTimezoneOffset(timezone) / 60 / 60 / 1000;
  }
  return tzOffset;
};

/**
 *
 * @param {string or Date} date - the Date object or the string
 *
 * @param {string or number} sourceTimezone
 *  the timezone string such as 'Australia/Melborne' or
 *  the timezone minutes such as 240 for UTC-4
 *  It is only used when 'isAccountTimezone' is true.
 *
 * @param {string or number} targetTimezone
 *  the timezone string such as 'Australia/Melborne' or
 *  the timezone minutes such as 240 for UTC-4,
 *  if undefined, it's the local timezone minutes.
 *
 * @returns - the UTC date string of the midday at the specified timezone such as 2022-04-01T16:00:00.000Z
 */
export function getDateMiddayInTimezone({
  date = new Date(),
  isAccountTimezone = false,
  sourceTimezone = new Date().getTimezoneOffset(),
  targetTimezone = new Date().getTimezoneOffset(),
}) {
  /**
   * date - 'Apr. 29 12:00 PM Fri GMT-4' of 'local timezone'
   *  or '04-29T02:00:00.000Z' of 'account.timezone' which is actually '04-29T12:00:00+10:00'
   *
   * newDate - the cloned date
   */
  const newDate = new Date(date);

  /**
   * targetTzOffset - the timezone offset such as '-4'
   */
  const targetTzOffset = getTzOffset(targetTimezone);

  /**
   * if 'date' is at 'account.timezone',
   * we should convert it to the date of 'local timezone'
   *
   * 'newDate' should be 'Apr. 29 12:00 PM Fri GMT-4'
   * when 'date' is '04-29T12:00:00+10:00'
   */
  if (isAccountTimezone) {
    const sourceTzOffset = getTzOffset(sourceTimezone);
    newDate.setTimezoneOffset(-sourceTzOffset * 60);
  }

  /**
   * dateStr - '04-29T12:00:00-04:00' or '04-29T12:00:00+10:00'
   */
  const dateStr = `${newDate.getFullYear()}-${makeTwo(newDate.getMonth() + 1)}-${makeTwo(newDate.getDate())}T12:00:00${
    targetTzOffset >= 0 ? "+" : "-"
  }${makeTimeoffset(targetTzOffset)}`;

  /**
   * the UTC date string such as
   *  '2022-04-01T16:00:00.000Z' for '2022-04-01T12:00:00-04:00'
   *  '2022-04-01T02:00:00.000Z' for '2022-04-01T12:00:00+10:00'
   */
  return new Date(dateStr).toISOString();
}
